import { IActionFind, IActionLoad, IActionRemove, IActionUpdate, UserTypes } from './types'
import { all, apply, call, put, takeLatest } from 'redux-saga/effects'
import { IActionType, IAxiosResponse } from '../root.types'
import {
    createUserFailure,
    createUserSuccess,
    findUserFailure,
    findUserSuccess,
    getUserLoggedFailure,
    getUserLoggedSuccess,
    loadAvatarFailure,
    loadAvatarSuccess,
    loadUserFailure,
    loadUserSuccess,
    removeAvatarFailure,
    removeAvatarSuccess,
    removeUserFailure,
    removeUserLoggedFailure,
    removeUserLoggedSuccess,
    removeUserSuccess,
    updateUserFailure,
    updateUserSuccess,
} from './actions'
import userService from "../../../services/user"
import { SnackBarMessageType } from '../../../components/layout/snackbar/index'
import { open } from '../snack.bar/actions'
import { push } from 'connected-react-router'
import { MAP_TYPE_USER_TO_ENDPOINT, TypesUser } from '../../application/models/user/user'
import authService from '../../../services/auth'
import avatarService from '../../../services/avatar'
import { changeAvatar } from '../layout/actions'

const typeEndPoint: string = "users"

function* loadUsers(action: IActionType<IActionLoad>) {
    try {
        const { typeUser, paginator } = action.payload

        const user: IAxiosResponse<any[]> = yield apply(
            userService,
            userService.getAll,
            [typeUser, paginator]
        )
        yield put(loadUserSuccess(user))
    } catch (e) {
        yield put(loadUserFailure())
    }
}


function* create(action: IActionType<IActionUpdate>) {
    try {
        const { user, avatar } = action.payload

        const response: any = yield apply(
            userService,
            userService.create,
            [user]
        )
        if (response.id && avatar?.name) {
            yield call(saveAvatar, response.id, avatar)
        }
        yield put<any>(createUserSuccess(response))
        yield put(push(`/app/${MAP_TYPE_USER_TO_ENDPOINT[user.type] || "administration"}`))
        yield put(open(SnackBarMessageType.SUCCESS, '', 'SNACKBAR.CREATE.MESSAGE'))

    } catch (e) {
        yield put(open(SnackBarMessageType.ERROR, '', "Não foi possivel criar o novo usuario"))
        yield put(createUserFailure(e))
    }
}
function* find(action: IActionType<IActionFind>) {
    try {
        const { userId, typeUser } = action.payload
        const user: IAxiosResponse<any> = yield apply(
            userService,
            userService.getById,
            [userId, typeUser]
        )
        yield put<any>(findUserSuccess(user))
    } catch (e) {
        yield put(findUserFailure())
    }
}
function* update(action: IActionType<IActionUpdate>) {
    try {
        const { user, avatar } = action.payload
        const userUpdate: IAxiosResponse<any> = yield apply(
            userService,
            userService.updade,
            [user]
        )
        if (userUpdate.data.id && avatar?.name) {
            yield call(saveAvatar, userUpdate.data.id, avatar)
        }
        yield put<any>(updateUserSuccess(userUpdate))
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Salvo atualização com sucesso`)
        )
        yield put(push(`/app/administration`))
    } catch (e) {
        open(
            SnackBarMessageType.ERROR,
            '',
            `Erro ao realizar a atualização`)

        yield put(updateUserFailure())
    }
}
function* remove(action: IActionType<IActionRemove>) {
    try {
        const { user } = action.payload
         yield apply(
            userService,
            userService.remove,
            [user]
        )
        yield put<any>(removeUserSuccess(user.id))
        yield put(push(`/app/administration`))
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Deletado usuario com sucesso`)
        )
    } catch (e) {
        open(
            SnackBarMessageType.ERROR,
            '',
            `Erro ao deletar o usuario`)

        yield put(removeUserFailure())
    }
}

export function* getUserLoggedForDashboard() {
    const userId = authService.decodeToken().sub
    const type = authService.decodeToken().sub_type
    if (userId && type) {
        try {
            const user: any = yield apply(
                userService,
                userService.getById,
                [userId, TypesUser[type as keyof typeof TypesUser]])
            yield put(getUserLoggedSuccess(user))
        } catch (e) {
            yield put(getUserLoggedFailure())
        }
    }
}

function* removeUserLogged(action: IActionType<IActionRemove>) {
    try {
        const { user } = action.payload
        yield apply(userService, userService.remove, [user.id])
        yield put<any>(removeUserLoggedSuccess(user.id))
        yield apply(authService, authService.logout, [])
        yield put(push(`/`))
    } catch (e) {
        yield put(removeUserLoggedFailure())
    }
}


function* saveAvatar(userId: string, avatar: any) {
    if (avatar) {
        yield apply(avatarService, avatarService.save, [userId, avatar, typeEndPoint])
    }
}

function* getAvatar(action: IActionType<IActionFind>) {
    const { userId } = action.payload
    try {
        const response: any = yield apply(avatarService, avatarService.get, [userId, typeEndPoint])
        yield put<any>(loadAvatarSuccess(response))
    } catch (e) {
        yield put(loadAvatarFailure())
    }
}

function* removeAvatar(action: IActionType<IActionFind>) {
    const { userId } = action.payload
    try {
        yield apply(avatarService, avatarService.remove, [userId, typeEndPoint])
        yield put<any>(removeAvatarSuccess())
        yield put(open(SnackBarMessageType.SUCCESS, '', 'SNACKBAR.REMOVE.AVATAR'))
        const userLoggedId: string = authService.decodeToken()?.sub || ''
        if (userLoggedId === userId) {
            yield put(changeAvatar(''))
        }
    } catch (e) {
        yield put(removeAvatarFailure())
    }
}

export default function* userSaga() {
    return yield all([
        takeLatest(UserTypes.CREATE_USER_REQUEST, create),
        takeLatest(UserTypes.FIND_USER_REQUEST, find),
        takeLatest(UserTypes.UPDATE_USER_REQUEST, update),
        takeLatest(UserTypes.LOAD_USER_REQUEST, loadUsers),
        takeLatest(UserTypes.REMOVE_USER_REQUEST, remove),
        takeLatest(UserTypes.GET_USER_LOGGED_REQUEST, getUserLoggedForDashboard),
        takeLatest(UserTypes.REMOVE_USER_LOGGED_REQUEST, removeUserLogged),
        takeLatest(UserTypes.LOAD_AVATAR_REQUEST, getAvatar),
        takeLatest(UserTypes.REMOVE_AVATAR_REQUEST, removeAvatar),
    ])
}